var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"descript_banner",style:({ 'background-image': `url(${_vm.detail.brandDescriptionImg})` })},[_c('div',{staticClass:"script_text"},[_c('h1',{staticClass:"v-html script_idea",domProps:{"innerHTML":_vm._s(_vm.brandUserVo.nickName)}}),_c('p',{staticClass:"v-html",domProps:{"innerHTML":_vm._s(_vm.detail.brandDescription)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }